module.exports = __webpack_public_path__ + "static/media/green-check.3454a96e.svg";